/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    TRACING_SYSTEM
 * Date:         2025-12-20
 * Modified By:  Cursor
 *
 * Description:
 * Client-side utility to capture device information for trace audit trail.
 * Collects browser info, screen resolution, timezone from browser APIs.
 */

export interface ClientDeviceInfo {
  platform: string;
  language: string;
  screenResolution: string;
  timezone: string;
}

/**
 * Capture client-side device information
 * Uses browser APIs to gather device metadata
 * @returns {ClientDeviceInfo} - Device information object
 */
export function captureClientDeviceInfo(): ClientDeviceInfo {
  try {
    return {
      platform: navigator.platform || "unknown",
      language: navigator.language || "unknown",
      // eslint-disable-next-line no-restricted-globals
      screenResolution: `${screen.width}x${screen.height}`,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || "unknown",
    };
  } catch (error) {
    console.warn("Failed to capture client device info:", error);
    return {
      platform: "unknown",
      language: "unknown",
      screenResolution: "unknown",
      timezone: "unknown",
    };
  }
}
